import { PropTypeMediaEntry } from "fleet/prop-types";
import isEqual from "lodash/isEqual";
import PropTypes from "prop-types";
import React from "react";
import { ContentArchived } from "ui/content-archived";

import { ContentGroupNavigator } from "./content-group-navigator";
import { ContentGroupPreview } from "./content-group-preview";
import { ContentPreview } from "./content-preview";
import { EditContentForm } from "./edit-content-form";
import { EditContentGroupForm } from "./edit-content-group-form";

class ContentGroupEditor extends React.PureComponent {
  static get propTypes() {
    return {
      categories: PropTypes.arrayOf(PropTypes.string),
      getChildState: PropTypes.func,
      getConfig: PropTypes.func.isRequired,
      hideFullscreen: PropTypes.func,
      isStrategy: PropTypes.bool,
      mediaEntry: PropTypeMediaEntry,
      showFullscreen: PropTypes.func,
    };
  }

  static get defaultProps() {
    return {
      getChildState: () => {},
      hideFullscreen: () => {},
      showFullscreen: () => {},
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      index: 0,
    };

    this._handleKeyDown = this._handleKeyDown.bind(this);
    this._navigateNext = this.navigate.bind(this, 1);
    this._navigatePrev = this.navigate.bind(this, -1);
    this.navigate = this.navigate.bind(this);
    this.navigateTo = this.navigateTo.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { mediaEntry } = this.props;
    const meChanged = !isEqual(
      mediaEntry,
      prevProps.mediaEntry,
    );

    if (meChanged) {
      this.setState({ index: 0 });
    }
  }

  _handleKeyDown(e) {
    if (e.key === "ArrowLeft") {
      this._navigatePrev();
    }

    if (e.key === "ArrowRight") {
      this._navigateNext();
    }
  }

  navigate(direction) {
    const { index } = this.state;
    const { mediaEntry } = this.props;
    const { numberOfSpots } = mediaEntry;

    if (direction > 0 && index === numberOfSpots - 1) {
      return;
    }

    if (direction < 0 && index === 0) {
      return;
    }

    this.navigateTo(index + direction);
  }

  navigateTo(index) {
    this.setState({ index });
  }

  render() {
    const {
      categories,
      getChildState,
      getConfig,
      hideFullscreen,
      isStrategy,
      mediaEntry,
      showFullscreen,
    } = this.props;
    const { index } = this.state;
    const { content, mimeType, numberOfSpots, type } = mediaEntry;
    const activeMediaEntry = content[index];
    const {
      mimeType: ameMimeType,
      name: ameName,
      type: ameType,
      url: ameUrl,
    } = activeMediaEntry;

    // Get content group active content configuration.
    const ameConfig = getConfig(ameType, ameMimeType);
    const {
      excludeFields: ameExcludeFields,
      readOnlyFields: ameReadonlyFields,
    } = ameConfig;

    // Get content group configuration.
    const config = getConfig(type, mimeType);
    const { readOnlyFields } = config;

    return (
      <div
        className="content-group-editor"
        onKeyDown={this._handleKeyDown}
        tabIndex="0"
      >
        <ContentGroupNavigator
          onNavigate={this.navigate}
          index={index}
          totalElements={numberOfSpots}
        />
        <ContentPreview
          type={ameType}
          url={ameUrl}
          mimeType={ameMimeType}
          name={ameName}
          hideFullscreen={hideFullscreen}
          showFullscreen={showFullscreen}
        />
        <ContentGroupPreview
          index={index}
          mediaEntries={content}
          navigateTo={this.navigateTo}
        />
        <ContentArchived mediaEntry={mediaEntry} parentOnly={true} />
        <ContentArchived mediaEntry={activeMediaEntry} />
        <EditContentGroupForm
          mediaEntry={mediaEntry}
          getState={getChildState}
          readOnlyFields={readOnlyFields}
        />
        <EditContentForm
          mediaEntry={activeMediaEntry}
          excludeFields={ameExcludeFields}
          categories={categories}
          getState={getChildState}
          readOnlyFields={isStrategy ? ameReadonlyFields : ["all"]}
        />
      </div>
    );
  }
}

export { ContentGroupEditor };
